import { initializeApp } from 'firebase/app'
import { getFunctions, httpsCallable } from 'firebase/functions'

import { 
  getFirestore,
  collection,
  getDocs,
  query,
  where,
  collectionGroup,
  deleteDoc, 
  doc, 
  updateDoc, 
  getDoc, 
  setDoc, 
  limit, 
  orderBy, 
  writeBatch, 
  addDoc,
  documentId,
} from 'firebase/firestore/lite'

import { getAuth, GoogleAuthProvider, EmailAuthProvider, deleteUser, updatePassword, signInAnonymously } from 'firebase/auth'
// const functions = getFunctions()

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FB_API_KEY,
  authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FB_DATABASE_URL,
  projectId: process.env.REACT_APP_FB_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FB_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FB_APP_ID,
  measurementId: process.env.REACT_APP_FB_MEASUREMENT_ID,
}

initializeApp(firebaseConfig)
const firestoreLite = getFirestore()
firestoreLite._settings.experimentalForceLongPolling = true
const authLite = getAuth(initializeApp(firebaseConfig))

export { 
  firestoreLite,
  httpsCallable,
  getFunctions,
  collection,
  getDocs,
  query,
  where,
  collectionGroup,
  deleteDoc, 
  doc, 
  updateDoc, 
  getDoc, 
  setDoc, 
  limit, 
  orderBy, 
  writeBatch, 
  addDoc,
  documentId, 
  authLite, 
  GoogleAuthProvider, 
  EmailAuthProvider,
  deleteUser,
  updatePassword,
  signInAnonymously 
}
